module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "userInfo",
    attrs: {
      "label-width": "150px",
      "model": _vm.userInfo,
      "rules": _vm.userInfoRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên đăng nhập",
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "name": "name"
    },
    model: {
      value: (_vm.userInfo.account),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "account", $$v)
      },
      expression: "userInfo.account"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Mật khẩu",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "type": "password",
      "name": "password"
    },
    model: {
      value: (_vm.userInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "password", $$v)
      },
      expression: "userInfo.password"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "passwordRepeat"
    }
  }, [_c('el-input', {
    staticClass: "col-10",
    attrs: {
      "type": "password",
      "name": "passwordRepeat"
    },
    model: {
      value: (_vm.userInfo.passwordRepeat),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "passwordRepeat", $$v)
      },
      expression: "userInfo.passwordRepeat"
    }
  })], 1), _c('el-form-item', {
    staticClass: "mb0"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('el-button', {
    staticClass: "col-12",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSignup
    }
  }, [_vm._v("Đăng ký")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6aaf660","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginPanel/signup.vue
// module id = 1003
// module chunks = 1